module.exports = __webpack_public_path__ + "img/candidates.6ea44f1a.svg";